import { Route } from 'react-router';
import { Routes } from 'react-router-dom';
import './App.css';

import { useContext } from 'react';
import { PanelHeader } from './components/header';
import { SideBar } from './components/sidebar';
import { LoginContext } from './context/LoginProvider';
import { Admins, CreateAdmin, UpdateAdmin } from './pages/admins';
import {
  Asignatures,
  CreateAsignature,
  UpdateAsignature,
} from './pages/asginatures';
import { Books, CreateBook, UpdateBook } from './pages/books';
import { ActivityCalifications } from './pages/califications/ActivityCalifications';
import { QuestionnaireCalifications } from './pages/califications/CuestionnaireCalifications';
import {
  ContextQuestions,
  CreateContextQuestions,
} from './pages/contextquestions';
import { UpdateContextQuestions } from './pages/contextquestions/UpdateContextQuestions';
import {
  Coordinators,
  CreateCoordinator,
  UpdateCoordinator,
} from './pages/coordinators';
import { Courses, CreateCourse, UpdateCourse } from './pages/courses';
import { CreateGlosary, Glosaries, UpdateGlosary } from './pages/glosary';
import { CreateGrade, Grades, UpdateGrade } from './pages/grades';
import { Home } from './pages/home';
import {
  CreateInstitution,
  Institutions,
  PersonalizeInstitution,
  UpdateInstitution,
} from './pages/institutions';
import { ToggleModules } from './pages/institutions/ToggleModules';
import { Login } from './pages/login/Login';
import { Maintenance } from './pages/maintenance/Maintenance';
import { CreatePin, Pines, UpdatePin } from './pages/pines';
import { CreateQuestion, Question, UpdateQuestion } from './pages/questions';
import { CreateResource, Resources, UpdateResource } from './pages/resources';
import { CreateSerie, Series, UpdateSerie } from './pages/series';
import { CreateStudent, Students, UpdateStudent } from './pages/students';
import { MasiveCharge } from './pages/students/MasiveCharge';
import { CreateTeacher, Teachers, UpdateTeacher } from './pages/teachers';
import { CreateWorkShop, WorkShops } from './pages/workshops';
import { ReviewWorkShop } from './pages/workshops/ReviewWorkShop';
import { WorkShopsPreview } from './pages/workshops/WorkShopsPreview';

function App() {
  const { user } = useContext(LoginContext);
  return (
    <>
      {(user && (
        <div className="main-panel">
          <div className="sidebar-container">
            <SideBar />
          </div>
          <div className="panel">
            <div className="panel-header">
              <PanelHeader />
            </div>
            <div className="panel-content">
              <Routes>
                <Route path="/admin" element={<Home />} />
                <Route path="/admin/admins" element={<Admins />} />
                <Route path="/admin/admins-create" element={<CreateAdmin />} />
                <Route
                  path="/admin/admins-update/:id"
                  element={<UpdateAdmin />}
                />
                <Route path="/admin/courses" element={<Courses />} />
                <Route
                  path="/admin/courses-create"
                  element={<CreateCourse />}
                />
                <Route
                  path="/admin/courses-update/:id"
                  element={<UpdateCourse />}
                />
                <Route path="/admin/grades" element={<Grades />} />
                <Route path="/admin/grades-create" element={<CreateGrade />} />
                <Route
                  path="/admin/grades-update/:id"
                  element={<UpdateGrade />}
                />
                <Route path="/admin/institutions" element={<Institutions />} />
                <Route
                  path="/admin/institutions-create"
                  element={<CreateInstitution />}
                />
                <Route
                  path="/admin/institutions-update/:id"
                  element={<UpdateInstitution />}
                />
                <Route
                  path="/admin/institutions-personalize"
                  element={<PersonalizeInstitution />}
                />
                <Route
                  path="/admin/institutions-modules"
                  element={<ToggleModules />}
                />
                <Route path="/admin/asignatures" element={<Asignatures />} />
                <Route
                  path="/admin/asignatures-create"
                  element={<CreateAsignature />}
                />
                <Route
                  path="/admin/asignatures-update/:id"
                  element={<UpdateAsignature />}
                />
                <Route path="/admin/series" element={<Series />} />
                <Route path="/admin/series-create" element={<CreateSerie />} />
                <Route
                  path="/admin/series-update/:id"
                  element={<UpdateSerie />}
                />
                <Route path="/admin/books" element={<Books />} />
                <Route path="/admin/books-create" element={<CreateBook />} />
                <Route
                  path="/admin/books-update/:id"
                  element={<UpdateBook />}
                />
                <Route path="/admin/pines" element={<Pines />} />
                <Route path="/admin/pines-create" element={<CreatePin />} />
                <Route path="/admin/pines-update/:id" element={<UpdatePin />} />
                <Route path="/admin/glosaries" element={<Glosaries />} />
                <Route
                  path="/admin/glosaries-create"
                  element={<CreateGlosary />}
                />
                <Route
                  path="/admin/glosaries-update/:id"
                  element={<UpdateGlosary />}
                />
                <Route path="/admin/questions" element={<Question />} />
                <Route
                  path="/admin/questions-create"
                  element={<CreateQuestion />}
                />
                <Route
                  path="/admin/questions-update/:id"
                  element={<UpdateQuestion />}
                />
                <Route path="/admin/resources" element={<Resources />} />
                <Route
                  path="/admin/resources-create"
                  element={<CreateResource />}
                />
                <Route
                  path="/admin/resources-update/:id"
                  element={<UpdateResource />}
                />
                <Route path="/admin/teachers" element={<Teachers />} />
                <Route
                  path="/admin/teachers-create"
                  element={<CreateTeacher />}
                />
                <Route
                  path="/admin/teachers-update/:id"
                  element={<UpdateTeacher />}
                />
                <Route path="/admin/students" element={<Students />} />
                <Route
                  path="/admin/students-create"
                  element={<CreateStudent />}
                />
                <Route
                  path="/admin/students-update/:id"
                  element={<UpdateStudent />}
                />
                <Route
                  path="/admin/students-charge"
                  element={<MasiveCharge />}
                />
                <Route path="/admin/coordinators" element={<Coordinators />} />
                <Route
                  path="/admin/coordinators-create"
                  element={<CreateCoordinator />}
                />
                <Route
                  path="/admin/coordinators-update/:id"
                  element={<UpdateCoordinator />}
                />
                <Route
                  path="/admin/contextquestions"
                  element={<ContextQuestions />}
                />
                <Route
                  path="/admin/contextquestions-create"
                  element={<CreateContextQuestions />}
                />
                <Route
                  path="/admin/contextquestions-update/:id"
                  element={<UpdateContextQuestions />}
                />
                <Route path="/admin/workshops" element={<WorkShops />} />
                <Route
                  path="/admin/workshops-create"
                  element={<CreateWorkShop />}
                />
                <Route
                  path="/admin/workshops-preview/:id"
                  element={<WorkShopsPreview />}
                />
                <Route
                  path="/admin/workshops-review/:id"
                  element={<ReviewWorkShop />}
                />
                <Route
                  path="/admin/califications-activities"
                  element={<ActivityCalifications />}
                />
                <Route
                  path="/admin/califications-questionnaires"
                  element={<QuestionnaireCalifications />}
                />
                <Route path="/admin/maintenance" element={<Maintenance />} />
              </Routes>
            </div>
          </div>
        </div>
      )) || <Login />}
    </>
  );
}

export default App;
